// extracted by mini-css-extract-plugin
export default {"footer":"_3TXsY","moreItemsText":"_1FdV5","mobileFooter":"_2FckC"};